<template>
    <GenericPopups ref="GenericPopups"></GenericPopups>
</template>

<script>
    import GenericPopups from "./GenericPopups";
    import _ from 'lodash';

    export default {
        name: "WeightValidation",
        components: {GenericPopups},
        GenericPopups: GenericPopups,
        data() {
            return {
                //apprsial prcoess
                //allowed weight variant is .3 per 20 dwt (rounded up), with a max of 1.0
                VARIANT_ADJUST_RATE_INTAKE: 20,
                VARIANT_ADJUST_AMOUNT_INTAKE: .3001,
                VARIANT_ADJUST_MAX_INTAKE: 1,

                //bag and print
                //.3dwt + (#of items *.05dwt) with a cap of 2dwt.
                VARIANT_ADJUST_AMOUNT_MIN_BAGGING_SUM: .3001,
                VARIANT_ADJUST_AMOUNT_PER_ITEM_BAGGING_SUM: .05,
                VARIANT_ADJUST_AMOUNT_MAX_BAGGING_SUM: 2.0,

                //QA
                //.4 dwt difference in bag weight when scanned.
                VARIANT_BAG_WEIGHT_QA: .4001,

                //RETURNS
                //base allowance is .4
                //severe error for greator range of min(1, max(.3*item, smallest item dwt))
                VARIANT_BASE_RANGE_RETURNS: .4001,
                VARIANT_ITEM_ADJUSTMENT: .3,
                VARIANT_OVERRIDE_RANGE_MAX_RETURNS: 1,

                //batch
                //.07 per item, min of .3dwt or lightest item. cap of 2.0.
                VARIANT_PER_ITEM_BATCH: .07,
                VARIANT_MIN_ALLOWED_BATCH: .3001,
                VARIANT_MAX_ALLOWED_BATCH: 2,

            };
        },
        methods: {
            validateIntakeWeight(pack, scale, managerOverrideAccept) {
                let intake_total_dwt = pack.intake_total_dwt;
                let variant = Math.min(_.round((intake_total_dwt + this.VARIANT_ADJUST_RATE_INTAKE ) / this.VARIANT_ADJUST_RATE_INTAKE) * this.VARIANT_ADJUST_AMOUNT_INTAKE, this.VARIANT_ADJUST_MAX_INTAKE);
                console.log(intake_total_dwt,scale,variant,_.round((intake_total_dwt / this.VARIANT_ADJUST_RATE_INTAKE) + this.VARIANT_ADJUST_RATE_INTAKE));
                if (_.round(Math.abs(intake_total_dwt - scale),2) >= variant) {
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'There is an issue with your package weight',
                            permission: 'manage inventory',
                            text: 'The total package weight for your order does not match the expected total package weight recorded during initial intake. Expected (' + intake_total_dwt + ') vs. Current Scale (' + scale + '). Please reweigh your package.',
                            ok: 'Manager Override', //manager override will do function
                            cancel: 'Ok', //cancel is a 'ok'
                            //todo MANAGER OVERRIDE
                            okAction: function () {

                                managerOverrideAccept();
                            },
                        };
                } else {
                    managerOverrideAccept();
                }
            },
            validateBaggingWeight(intake_inventory_weight, inventoryByMelt){
                let total = 0;
                let count = 0;
                let smallest = this.VARIANT_ADJUST_AMOUNT_MAX_BAGGING_SUM;
                _.forEach(inventoryByMelt, (bag) =>{
                    _.forEach(bag, (e) => {
                        let val = parseFloat(e.aggregate_dwt);
                        val = val || 0;
                        smallest = Math.min(val, smallest);
                        total += val;
                        count++;
                    });
                });
                let variance =
                    Math.min(
                        this.VARIANT_ADJUST_AMOUNT_MIN_BAGGING_SUM
                        + (count * this.VARIANT_ADJUST_AMOUNT_PER_ITEM_BAGGING_SUM),
                        this.VARIANT_ADJUST_AMOUNT_MAX_BAGGING_SUM
                    );
                console.log(inventoryByMelt,total,intake_inventory_weight,variance);
                return variance >= _.round(Math.abs(total-intake_inventory_weight),2);
            },
            validateQAWeight(scaleWeight, bagWeight){
                return _.round(Math.abs(scaleWeight - bagWeight),2) <= this.VARIANT_BAG_WEIGHT_QA;
            },
            WeightValidationReturns(scaleWeight, itemParse, uponInvalid=function(){}, uponApprove=function(){}){
                let max_variant = _.max(
                    [
                        _.min(_.map(itemParse, (e)=>{return e.aggregate_dwt})),
                        this.VARIANT_ITEM_ADJUSTMENT * itemParse.length
                    ]
                );

                // Allow for a single weight vs an array of items
                let aggregate_dwt = 0;
                if (typeof itemParse === 'number') {
                    aggregate_dwt = itemParse;
                } else {
                    aggregate_dwt = _.sumBy(itemParse, (e)=>{return e.aggregate_dwt;});
                }

                let difference = _.round(Math.abs(aggregate_dwt - scaleWeight),2);
                console.log(difference, max_variant,);
                if(difference <= this.VARIANT_BASE_RANGE_RETURNS){
                    uponApprove();
                    return;
                }
                else if(difference <= max_variant){
                    //TODO manager override
                    this.$refs.GenericPopups.displayPermission =
                        {
                            title: 'There is an issue with your weight',
                            text: 'Your current weight does not meet the expected weight of the items being returned for this order. Please double check your items.',
                            permission: 'manage inventory',
                            okAction: () => {
                                //note manager override was done. weights forced validation
                                uponApprove();

                            },
                            cancel: 'Ok',
                            ok: 'Manager Override',
                        };
                    uponInvalid();
                } else {
                    //warning message
                    this.$refs.GenericPopups.displayError =
                        {
                            title: 'There is an issue with your weight',
                            text: 'Your current weight does not meet the expected weight of the items being returned for this order. Please double check your items.',
                        };
                    uponInvalid();
                }
                //this.$refs.GenericPopups
            },
            validateBatch(scanWeight, batchBags){
                //assumed it is only bags of melt and not melee
                let calculatedWeight = 0.0;
                let minWeight = this.VARIANT_MAX_ALLOWED_BATCH;
                let itemCount = 0.0;
                if(batchBags.length == 0) {
                    return true;
                }
                _.forEach(batchBags, bag => {
                    //fixme WE NEED TO ACCOUNT FOR MELEE CONTAINING BAGS THREW OUT THE API
                    if (!bag.isMelee) {
                        _.forEach(bag.child_items, item => {
                            itemCount++;
                            let dwt = parseFloat(item.dwt);
                            console.log(dwt,minWeight);
                            minWeight = _.min([dwt, minWeight]);
                            calculatedWeight += dwt;
                            console.log(dwt, minWeight);
                        });
                        calculatedWeight += parseFloat(bag.container.bagType.bag_dwt);
                    }
                });
                console.log(minWeight, itemCount);
                let weightVariant = _.min([
                    minWeight,
                    _.max([itemCount * this.VARIANT_PER_ITEM_BATCH, this.VARIANT_MIN_ALLOWED_BATCH]),
                    this.VARIANT_MAX_ALLOWED_BATCH
                ]);
                let difference = _.round(Math.abs(calculatedWeight - scanWeight),2);
                console.log(calculatedWeight, scanWeight);
                console.log(difference, weightVariant);
                return difference <= weightVariant;
            }
        }
    }
</script>

<style scoped>

</style>